import { IsAlphanumeric, IsOptional, Matches, MaxLength, IsNotEmpty, IsDate } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class DesignationActionDTO{
     @ApiProperty()
     @IsNotEmpty({message: 'Deignation-action Id should not be empty'})
     @IsAlphanumeric()
     @IsOptional()
     designationActionId: number;

     @ApiProperty()
    @IsDate()
    designationDate: Date;

    @ApiProperty()
     @IsNotEmpty({message: 'Employee code should not be empty'})
     employeeCode: string;

     @ApiProperty()
     @IsNotEmpty({message: 'Employee name should not be empty'})
     employeeName: string;

     @ApiProperty()
     @IsNotEmpty({message: 'department should not be empty'})
     department: string;

     @ApiProperty()
     @IsNotEmpty({message: 'toDepartment should not be empty'})
     toDepartment: string;

     @ApiProperty()
     @IsNotEmpty({message: 'Employee id should not be empty'})
     employeeId: number;

     @ApiProperty()
     @IsNotEmpty({message: 'from designation should not be empty'})
     fromDesignation: string;

     @ApiProperty()
     @IsNotEmpty({message: 'tode signation should not be empty'})
     toDesignation: string;

     @ApiProperty()
     @IsNotEmpty({message: 'Employee name should not be empty'})
     approvedBy: string;

     @ApiProperty()
     isActive: boolean;

     createdAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Created user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Created User should be only alphabets'})
     createdUser: string;

     updatedAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Updated user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Updated user should be only characters'})
     updatedUser: string;

     @ApiProperty()
     versionFlag: number;

     // @ApiProperty()
     // fromDepartmentId:number;

     // @ApiProperty()
     // toDepartmentId:number;
}